var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIndicatorProtector = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 176 176"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "indicator-protector_svg__a",
  cx: "50%",
  cy: "50.787%",
  r: "49.213%",
  fx: "50%",
  fy: "50.787%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopOpacity: 0.415
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopOpacity: 0
})))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#indicator-protector_svg__a)",
  fillRule: "evenodd",
  d: "M391 182h176v176H391z",
  transform: "translate(-391 -182)"
})));
export default SvgIndicatorProtector;